/* Condom size calculator (csz-). Data comes from #csz-blob (built by condom-calculator/gen.py).
   Inputs are kept in inches inside. Condom sizes are nominal widths in mm (the flat width printed on the box).
   Fit rule: a condom that fits is a little narrower than you, so it stretches. pnw = girth / 2, condom width = pnw / (1 + stretch). */
(function () {
  var root = document.getElementById('csz-app');
  var blob = document.getElementById('csz-blob');
  if (!root || !blob) return;
  var D = JSON.parse(blob.textContent);
  var CM = 2.54, MM = 25.4, IMG = root.getAttribute('data-img') || '';
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

  function erf(x) {
    var s = x < 0 ? -1 : 1; x = Math.abs(x);
    var t = 1 / (1 + 0.3275911 * x);
    var y = 1 - (((((1.061405429 * t - 1.453152027) * t) + 1.421413741) * t - 0.284496736) * t + 0.254829592) * t * Math.exp(-x * x);
    return s * y;
  }
  function Phi(z) { return 0.5 * (1 + erf(z / Math.SQRT2)); }

  /* ---------- fit math ---------- */
  function fit(Gin) {
    var pnw = Gin * MM / 2;
    return { pnw: pnw, ideal: pnw / (1 + D.fit.mid), lo: pnw / (1 + D.fit.hi), hi: pnw / (1 + D.fit.lo) };
  }
  function sizeLabel(ideal) {
    for (var i = 0; i < D.bands.length - 1; i++) if (Math.abs(ideal - D.bands[i].max) < 0.75) return D.bands[i].label + ' or ' + D.bands[i + 1].label.toLowerCase();
    return bandOf(ideal).label;
  }
  function topUnique(list, n) {
    var seen = {}, out = [];
    [false, true].forEach(function (fam) {
      for (var i = 0; i < list.length && out.length < n; i++) {
        var p = list[i]; if (!!p.c.items !== fam || seen[p.c.b]) continue; seen[p.c.b] = 1; out.push(p);
      }
    });
    return out;
  }
  /* one plain word for how a condom will feel on you (stretch = your half-girth over the condom width) */
  function feel(p) {
    var s = lastFit.pnw / p.w - 1;
    if (s < 0.08) return { k: 'roomy', w: 'Roomy fit', t: 'A little looser. Comfortable, but go one size down if it slips.' };
    if (s <= 0.16) return { k: 'good', w: 'Perfect fit', t: 'Made for your size. It should feel snug but comfortable.' };
    return { k: 'snug', w: 'Snug fit', t: 'A little tighter. Feels secure, but go one size up if it squeezes.' };
  }
  function extras(p) {
    var x = [];
    if (p.c.m !== 'latex') x.push('Latex-free');
    if (p.c.where && p.c.where !== 'US') x.push(/^UK/.test(p.c.where) ? 'UK and EU only' : p.c.where + ' only');
    if (p.short) x.push('May be too short for you');
    return x;
  }
  function bandOf(w) { w = Math.round(w); for (var i = 0; i < D.bands.length; i++) if (w < D.bands[i].max) return D.bands[i]; return D.bands[D.bands.length - 1]; }
  /* one row per product; a product sold in many widths (MyONE, MY.SIZE) uses the width closest to you,
     then MyONE's length letter for your length if you gave one */
  function famPick(c, f, Lin) {
    var ws = [];
    c.items.forEach(function (it) { if (it[0] >= f.lo - 0.01 && it[0] <= f.hi + 0.01 && ws.indexOf(it[0]) < 0) ws.push(it[0]); });
    if (!ws.length) return null;
    ws.sort(function (a, b) { return Math.abs(a - f.ideal) - Math.abs(b - f.ideal); });
    var w = ws[0], its = c.items.filter(function (it) { return it[0] === w; }), it = its[0];
    if (c.lenrule === 'myone') {
      if (!Lin) return { w: w, d: Math.abs(w - f.ideal), code: String(w), l: null, needLen: true };
      var lp = Lin * MM, letter = 'M';
      for (var i = 0; i < D.letters.length; i++) if (lp <= D.letters[i][0]) { letter = D.letters[i][1]; break; }
      it = its.filter(function (x) { return x[2].slice(-1) === letter; })[0] ||
        its.slice().sort(function (a, b) { return Math.abs(a[1] - lp - 10) - Math.abs(b[1] - lp - 10); })[0];
    }
    return { w: w, d: Math.abs(w - f.ideal), code: it[2], l: it[1] };
  }
  function picks(f, Lin, latexFree) {
    var out = [];
    D.condoms.forEach(function (c) {
      if (latexFree && c.m === 'latex') return;
      var best = c.items ? famPick(c, f, Lin) : (c.w >= f.lo - 0.01 && c.w <= f.hi + 0.01 ? { w: c.w, d: Math.abs(c.w - f.ideal), code: null, l: c.l } : null);
      if (!best) return;
      var short = !!(Lin && best.l && Lin * MM > best.l + 12.7);
      out.push({ c: c, w: best.w, d: best.d + (short ? 100 : 0) + (c.where && c.where !== 'US' ? 0.6 : 0), code: best.code, l: best.l, lt: c.items ? null : c.ltxt, needLen: best.needLen, short: short });
    });
    out.sort(function (a, b) { return a.d - b.d || (a.c.rank || 9) - (b.c.rank || 9); });
    return out;
  }

  /* ---------- state ---------- */
  var st = { u: 'in', G: D.ex.G, L: D.ex.L, t: 'any', example: true };
  (function init() {
    var p = new URLSearchParams(location.search);
    st.u = p.get('u') === 'cm' || (!p.get('u') && !/^en/i.test(navigator.language || 'en')) ? 'cm' : 'in';
    var num = function (k) { var v = parseFloat(p.get(k)); return isFinite(v) && v > 0 ? v : null; };
    var k = st.u === 'cm' ? 1 / CM : 1;
    if (num('g')) { st.G = num('g') * k; st.example = false; }
    if (num('l')) { st.L = num('l') * k; } else if (!st.example) st.L = null;
    if (p.get('t') === 'lf') st.t = 'lf';
  })();
  var fmt = function (inches, dp) { var v = st.u === 'cm' ? inches * CM : inches; return v.toFixed(dp == null ? 1 : dp); };
  var unit = function () { return st.u === 'cm' ? 'cm' : 'in'; };
  var round = function (p) { return p < 1 ? '<1' : p > 99 ? '99+' : String(Math.round(p)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- inputs ---------- */
  var RANGE = { G: [2.5, 8], L: [2, 11] };
  function syncInputs() {
    ['G', 'L'].forEach(function (k) { var n = $('[data-num="' + k + '"]'); if (n && document.activeElement !== n) n.value = st[k] == null ? '' : fmt(st[k]); });
    $$('[data-unit-lbl]').forEach(function (el) { el.textContent = unit(); });
    $$('[data-u]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.u === st.u)); });
    $$('[data-t]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.t === st.t)); });
  }
  function readNum(k, raw) {
    if (String(raw).trim() === '' && k === 'L') { st.L = null; return true; }
    var v = parseFloat(String(raw).replace(',', '.'));
    if (!isFinite(v) || v <= 0) return false;
    var inches = st.u === 'cm' ? v / CM : v;
    st[k] = Math.min(RANGE[k][1], Math.max(RANGE[k][0], inches));
    return true;
  }
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.dataset.num && readNum(t.dataset.num, t.value)) { st.example = false; render(); }
  });
  root.addEventListener('blur', function (e) { if (e.target.dataset && e.target.dataset.num) { var k = e.target.dataset.num; e.target.value = st[k] == null ? '' : fmt(st[k]); } }, true);
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
    if (b.dataset.u) { st.u = b.dataset.u; syncInputs(); render(); }
    else if (b.dataset.t) { st.t = b.dataset.t; st.example = false; syncInputs(); render(); }
    else if (b.hasAttribute('data-pick')) openPick(+b.getAttribute('data-pick'));
    else if (b.hasAttribute('data-more')) { var open = b.getAttribute('aria-expanded') !== 'true'; b.setAttribute('aria-expanded', String(open)); $('[data-panel="all"]').hidden = !open; b.textContent = open ? 'Hide the full list' : b.dataset.label; }
  });

  /* ---------- pop-ups (stay on the calculator) ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-pop]');
    if (o) { var d = document.getElementById('csz-pop-' + o.dataset.pop); if (d) { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); } return; }
    var c = e.target.closest('[data-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) { if (dd.close) dd.close(); else dd.removeAttribute('open'); } return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('csz-pop') && e.target.close) e.target.close();
  });

  /* ---------- results ---------- */
  var lastList = [], lastFit = null, UPG = 0.63;
  function an(w) { return /^[aeiou]/i.test(w) ? 'an' : 'a'; }
  function openPick(i) {
    var p = lastList[i], d = document.getElementById('csz-pop-pick'); if (!p || !d) return;
    var set = function (k, v) { var e = d.querySelector('[data-out="' + k + '"]'); if (e) { e.textContent = v; e.hidden = !v; } };
    var f = feel(p), x = extras(p);
    set('pkT', p.c.b + ' ' + p.c.p);
    var im = d.querySelector('[data-out="pkI"]'); im.hidden = !p.c.img; if (p.c.img) { im.src = IMG + 'csz-p-' + p.c.img + '.webp'; im.alt = p.c.b + ' ' + p.c.p + ' condoms'; }
    set('pkF', f.w); d.querySelector('[data-out="pkF"]').className = 'csz-fw csz-fw--' + f.k;
    set('pkFs', f.t);
    set('pkW', 'Box size ' + (+p.w.toFixed(1)) + ' mm');
    var n = x.slice();
    if (p.c.items) n.push(p.needLen ? 'Comes in many sizes. Add your length above and we will show your exact one.' : 'Comes in many sizes. Yours is size ' + p.code + '.');
    set('pkM', n.join(' · '));
    if (d.showModal) d.showModal(); else d.setAttribute('open', '');
  }
  function drawUp(f) {
    var box = $('[data-out="up"]'); if (!box) return;
    var xl = Math.round(f.ideal) >= D.bands[D.bands.length - 2].max;
    var pump = box.querySelector('[data-up="pump"]'), ext = box.querySelector('[data-up="ext"]');
    pump.hidden = xl; ext.hidden = !xl;
    var a = box.querySelector('[data-out="upA"]');
    if (!xl) {
      var lab = sizeLabel(f.ideal).toLowerCase(), f2 = fit(st.G + UPG), lab2 = sizeLabel(f2.ideal).toLowerCase();
      $('[data-out="upK"]').textContent = 'Want to go up a size?';
      $('[data-out="upT"]').textContent = 'Today you fit ' + an(lab) + ' ' + lab + ' condom, about ' + Math.round(f.ideal) + ' mm.';
      $('[data-out="upP"]').textContent = 'The top 10% of men pumping in our app gained ' + UPG + ' inches of girth or more by month 12. That much would move you up to about ' + Math.round(f2.ideal) + ' mm, ' + an(lab2) + ' ' + lab2 + ' condom.';
      a.textContent = 'See the Epic Pump kits'; a.href = '/collections/penis-pumps';
    } else {
      var pg = 100 * Phi((st.G * CM - D.veale[0]) / D.veale[1]);
      $('[data-out="upK"]').textContent = 'Want length to match?';
      $('[data-out="upT"]').textContent = 'Your girth is thicker than ' + Math.min(99, Math.round(pg)) + ' out of 100 men.';
      $('[data-out="upP"]').textContent = '90% of men in our app with 250+ extender hours gained length, and 1 in 5 gained an inch or more.';
      a.textContent = 'See the Epic Pro extender'; a.href = '/products/epic-pro-starter-kit';
    }
  }
  function row(p, best, idx) {
    var f = feel(p), x = extras(p);
    var th = p.c.img ? '<img class="csz-th" src="' + IMG + 'csz-p-' + p.c.img + '.webp" width="76" height="76" alt="' + esc(p.c.b + ' ' + p.c.p) + ' condoms">' : '<s class="csz-th" aria-hidden="true"></s>';
    return '<li><button type="button" class="csz-pick' + (best ? ' csz-pick--best' : '') + '" data-pick="' + idx + '">' + th + '<span class="csz-pick__t"><b>' + esc(p.c.b + ' ' + p.c.p) + (best ? '<span class="csz-tag">Best pick</span>' : '') + '</b>' +
      '<span><em class="csz-fw csz-fw--' + f.k + '">' + f.w + '</em>' + (x.length ? ' · ' + esc(x.join(' · ')) : '') + '</span></span><i>' + (+p.w.toFixed(1)) + ' mm</i></button></li>';
  }
  function render() {
    var f = fit(st.G), b = bandOf(f.ideal), lf = st.t === 'lf';
    var list = picks(f, st.L, lf); lastList = list; lastFit = f;
    $('[data-out="example"]').hidden = !st.example;
    $('[data-out="mm"]').innerHTML = Math.round(f.ideal) + '<small>mm</small>';
    $('[data-out="band"]').textContent = sizeLabel(f.ideal);
    $('[data-out="range"]').textContent = 'Look for ' + Math.round(f.lo) + ' to ' + Math.round(f.hi) + ' mm on the box';
    var pg = 100 * Phi((st.G * CM - D.veale[0]) / D.veale[1]);
    $('[data-out="pct"]').textContent = 'Your girth is thicker than ' + round(pg) + ' out of 100 men measured by doctors.';
    drawScale(f, b);
    $('[data-out="count"]').textContent = list.length ? list.length + ' fit you' : 'None found';
    var top = topUnique(list, 4);
    $('[data-out="picks"]').innerHTML = top.map(function (p, i) { return row(p, i === 0, list.indexOf(p)); }).join('');
    var none = $('[data-out="none"]');
    none.hidden = !!list.length;
    if (!list.length) none.textContent = f.ideal < D.scale[0] + 4 ? D.msg.small : f.ideal > D.scale[1] - 6 ? D.msg.big : (lf ? D.msg.lf : D.msg.mid);
    var more = $('[data-more]');
    more.hidden = list.length <= top.length;
    more.dataset.label = 'See all ' + list.length + ' that fit';
    if (more.getAttribute('aria-expanded') !== 'true') more.textContent = more.dataset.label;
    $('[data-out="all"]').innerHTML = list.map(function (p) {
      var t = p.c.img ? '<img class="csz-th" src="' + IMG + 'csz-p-' + p.c.img + '.webp" width="44" height="44" loading="lazy" alt="">' : '<s class="csz-th" aria-hidden="true"></s>';
      var f = feel(p), x = extras(p);
      return '<tr><th scope="row"><button type="button" class="csz-tn csz-linkbtn" data-pick="' + list.indexOf(p) + '">' + t + '<span>' + esc(p.c.b + ' ' + p.c.p) + '</span></button></th>' +
        '<td><em class="csz-fw csz-fw--' + f.k + '">' + f.w + '</em>' + (x.length ? '<small class="csz-x">' + esc(x.join(' · ')) + '</small>' : '') + '</td><td class="n">' + (+p.w.toFixed(1)) + ' mm</td></tr>';
    }).join('');
    drawUp(f);
    saveUrl();
  }
  function saveUrl() {
    if (st.example) return;
    var p = new URLSearchParams(location.search), k = st.u === 'cm' ? CM : 1;
    p.set('g', (st.G * k).toFixed(1));
    if (st.L) p.set('l', (st.L * k).toFixed(1)); else p.delete('l');
    p.set('u', st.u);
    if (st.t === 'lf') p.set('t', 'lf'); else p.delete('t');
    try { history.replaceState(null, '', location.pathname + '?' + p.toString() + location.hash); } catch (e) {}
  }

  /* size scale: the condom sizes as one bar, your fit range shaded, your size marked */
  function drawScale(f, b) {
    var svg = $('[data-out="scale"]'); if (!svg) return;
    var W = Math.max(260, Math.min(620, (svg.parentNode.clientWidth || 360) - 2)), H = 96, x0 = 8, x1 = W - 8, a = D.scale[0], z = D.scale[1];
    var X = function (w) { return x0 + (Math.max(a, Math.min(z, w)) - a) / (z - a) * (x1 - x0); };
    var out = '', prev = a, yb = 46, hb = 22;
    D.bands.forEach(function (bd) {
      var e = Math.min(z, bd.max - 0.5);
      out += '<rect class="csz-sc-seg" x="' + X(prev).toFixed(1) + '" y="' + yb + '" width="' + (X(e) - X(prev)).toFixed(1) + '" height="' + hb + '" rx="6" fill="' + bd.color + '"/>';
      var mid = (X(prev) + X(e)) / 2, wpx = X(e) - X(prev);
      if (wpx > 30) out += '<text class="csz-sc-lbl" x="' + mid.toFixed(1) + '" y="' + (yb + 15) + '" fill="' + (bd.dark ? '#fff' : '#1A1A1A') + '">' + (wpx > 66 ? bd.label : bd.short).toUpperCase() + '</text>';
      prev = e;
    });
    var r0 = X(f.lo), r1 = X(f.hi), ry = yb - 8;
    out += '<path class="csz-sc-br" d="M' + r0.toFixed(1) + ' ' + (ry + 5) + ' V' + ry + ' H' + r1.toFixed(1) + ' V' + (ry + 5) + '"/>';
    for (var t = Math.ceil(a / 5) * 5; t <= z; t += 5) out += '<text class="csz-sc-tk" x="' + X(t).toFixed(1) + '" y="' + (H - 6) + '">' + t + '</text>';
    var yx = X(f.ideal);
    out += '<path class="csz-sc-you" d="M' + (yx - 8).toFixed(1) + ' ' + (ry - 16) + ' L' + (yx + 8).toFixed(1) + ' ' + (ry - 16) + ' L' + yx.toFixed(1) + ' ' + (ry - 2) + ' Z"/>';
    out += '<text class="csz-sc-youl" x="' + Math.max(48, Math.min(W - 48, yx)).toFixed(1) + '" y="' + (ry - 21) + '">You ' + Math.round(f.ideal) + ' mm</text>';
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.innerHTML = out;
  }
  var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { var f = fit(st.G); drawScale(f, bandOf(f.ideal)); }, 150); });

  if (/[?&]cszdebug=1/.test(location.search)) window.cszDebug = { fit: fit, picks: function (g, l, lf) { return picks(fit(g), l, lf).map(function (p) { return [p.c.b + ' ' + p.c.p + (p.code ? ' ' + p.code : ''), p.w, p.short]; }); } };

  syncInputs();
  render();
  root.classList.add('is-ready');
})();
